import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NavbarProfile from "./components/NavbarProfile";
import { ReactComponent as MenuMobileIcon } from "../../assets/icons/mobile-menu.svg";
import { SIDEBAR_ACTION_TYPE } from "../../redux/actions-type";

export const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openSidebarFunc = () => {
    dispatch({ type: SIDEBAR_ACTION_TYPE.SIDEBAR_OPEN_MODAL, payload: true });
  };
  const { openSidebar } = useSelector((state) => state.openSidebar);

  const getPageTitle = (pathname) => {
    if (pathname.includes("/updates") && pathname.includes("/student"))
      return "Tələbələr > yeniləmələr";
    if (pathname.includes("/updates") && pathname.includes("/group"))
      return "Qruplar > yeniləmələr";
    if (pathname.includes("/updates") && pathname.includes("/tuition-fee"))
      return "Təhsil haqqı > yeniləmələr";
    switch (pathname) {
      case "/groups/current":
        return "Qruplar";
      case "/groups/waiting":
        return "Qruplar";
      case "/workers":
        return "Əməkdaşlar";
      case "/room":
        return "Otaqlar";
      case "/room/calendar":
        return "Otaq təqvimi";
      case "/students":
        return "Tələbələr";
      case "/teachers":
        return "Təlimçilər";
      case "/teachers/mentors":
        return "Təlimçilər";
      case "/courses":
        return "Fənlər";
      case "/tuition-fee":
        return "Təhsil haqqı";
      case "/career":
        return "Karyera";
      case "/consultation":
        return "Konsultasiya";
      case "/syllabus":
        return "Sillabus";
      case "/sales":
        return "Satış";
      case "/":
      case "/lesson":
        return "Dərs cədvəli";
      case "/event":
        return "Tədbirlər";
      case "/dashboard":
        return "İdarəetmə paneli";
      case "/teacher-panel":
        return "Dərs cədvəli";
      case "/student-panel":
        return "Dərs cədvəli";
      case "/diploma":
        return "Diplom Cədvəli";
      case "/report":
        return "Hesabatlar cədvəli";
      case "/whereHeard":
        return "Reklam növləri";
      case "/notifications":
        return "Bildirişlər";
      default:
        return "";
    }
  };
  const pageTitle = getPageTitle(location.pathname);

  return (
    <>
      <header className={`main-header ${openSidebar ? "open" : ""} `}>
        <div className="container">
          <div className="header-content">
            <div className="header-content-container">
              <div className="header-context">
                <MenuMobileIcon onClick={openSidebarFunc} />
                <h2>{pageTitle}</h2>
              </div>
              <div className="header-icons">
                <NavbarProfile />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
